import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { HttpHandlingService } from 'src/app/api/services/http-handling.service';
import { SERVER_API_URL } from 'src/app/common/types/app.constants';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html'
})
export class ForgotPasswordDialogComponent implements OnInit {

  form: UntypedFormGroup;
  hide: boolean | null = true;
  serverIsDown: boolean = false;

  constructor(builder: UntypedFormBuilder, public dialogRef: MatDialogRef<ForgotPasswordDialogComponent>, private httpHandlingService: HttpHandlingService, private http: HttpClient) {
    this.form = builder.group({
      login: [null, Validators.required],
      password: [null, [Validators.minLength(6), Validators.maxLength(24), Validators.required]],
      newPassword: [null, [Validators.minLength(6), Validators.maxLength(24), Validators.required, this.passwordMatcher.bind(this)]],
    });
   }

  ngOnInit(): void {
  }

  // confirm new password validator
  private passwordMatcher(group: UntypedFormGroup): { [s: string]: boolean } {
    console.log(group);
    if (
      group.get('password')?.value &&
        (group.get('password')?.value !== group.get('newPassword')?.value)
    ) {
        return { passwordNotMatch: true };
    }
    return null;
  }

  changePassword(): void {
    const changePassword = {...this.form.value, ['password']: undefined};
    const getCrewsByCompetitorURL = SERVER_API_URL + '/api/users/change-password-by-login';
    this.http.post(getCrewsByCompetitorURL, changePassword).subscribe();
  }

  /**
   * function which provides error messages in the process of logging in
   * @param fieldControl with information about desired field (login, password)
   */
  getErrorMessage(fieldControl: UntypedFormControl): string {
    return this.httpHandlingService.handleUserErrorOutput(fieldControl);
  }

}
